var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-drr',{ref:"widget",staticClass:"widget-container",style:({
    zIndex: _vm.zIndex
  }),attrs:{"parent":true,"rotatable":true,"w":_vm.w,"h":_vm.h,"x":_vm.x,"y":_vm.y,"angle":_vm.r},on:{"dragstop":_vm.dragStop,"rotatestop":_vm.rotateStop,"resizestop":_vm.resizeStop}},[_c('div',{staticClass:"widget animated bounceIn",style:({
      justifyContent: _vm.justifyContent,
      alignItems: _vm.alignItems
    }),attrs:{"id":("widget" + _vm.id)},on:{"click":_vm.setActiveWidget}},[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/placeholder_web_200x200.jpg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }